import styled from 'styled-components';
import GreenTexture from 'assets/images/ambassador/green-texture.jpg';
import { POPPINS_FAMILY } from 'styles/poppins_font';

const GREEN = '#10a875';
const DARK_GREEN = '#043e2c';

// Textura do protótipo coberta pelo verde translúcido, usada no topo e na seção de papéis.
const TEXTURED_GREEN = `linear-gradient(rgba(11, 113, 81, 0.76), rgba(11, 113, 81, 0.76)), url(${GreenTexture}) center bottom / 100% 100% no-repeat`;

export const Container = styled.div`
  overflow-x: hidden;
  background: ${(props) => props.theme.$white};
  color: ${DARK_GREEN};
  font-family: ${POPPINS_FAMILY};
  line-height: normal;

  h1,
  h2,
  p {
    margin: 0;
  }

  h2 {
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
  }

  /*
   * O conteúdo acompanha a largura da faixa verde (até 1184px) e o padding de
   * baixo desconta a metade dela que cobre a seção.
   */
  .hero {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 48px;
    height: 400px;
    padding: 0 max(91px, calc((100% - 1184px) / 2)) 16px;
    overflow: hidden;
    background: ${TEXTURED_GREEN};
  }

  .hero-text {
    display: flex;
    flex: 0 1 567px;
    flex-direction: column;
    gap: 20px;
    min-width: 0;
    color: ${(props) => props.theme.$white};

    h1 {
      font-size: 38px;
      font-weight: 700;
      line-height: 47.431px;
    }

    p {
      font-size: 20px;
      font-weight: 300;
    }
  }

  .hero-video {
    flex: 0 1 512px;
    min-width: 0;
    overflow: hidden;
    border-radius: 15px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
  }

  .hero-video-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    aspect-ratio: 16 / 9;
    padding: 0 16px;
    background: rgba(4, 62, 44, 0.55);
    color: ${(props) => props.theme.$white};
    font-size: 14px;
    text-align: center;

    .material-icons {
      font-size: 48px;
    }
  }

  /* Faixa arredondada que fica metade sobre a seção verde, metade sobre a branca. */
  .green-bar {
    position: relative;
    z-index: 1;
    width: calc(100% - 161px);
    max-width: 1205px;
    height: 32px;
    margin: -16px auto 0;
    border-radius: 19px;
    background: ${GREEN};
  }

  .hero-bar {
    left: -5.5px;
  }

  .roles-bar {
    left: 3.5px;
  }

  .benefits {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 16px 76px;
    text-align: center;

    h2 {
      color: ${GREEN};
    }
  }

  .section-subtitle {
    margin-top: 10px;
    font-size: 18px;
    font-weight: 300;
  }

  .benefit-list {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    width: 100%;
    max-width: 1116px;
    margin: 44px 0 0;
    padding: 0;
    list-style: none;
    text-align: left;
  }

  .benefit-card {
    flex: 0 1 calc((100% - 60px) / 3);
    min-height: 184px;
    padding: 19px 26px 18px;
    border-radius: 15px;
    background: ${(props) => props.theme.$gray100};

    .benefit-number {
      display: block;
      color: ${GREEN};
      font-size: 28px;
      font-weight: 700;
    }

    strong {
      display: block;
      margin-top: 6px;
      font-size: 18px;
      font-weight: 700;
    }

    p {
      font-size: 16px;
      font-weight: 300;
    }
  }

  .accept-action {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    margin-top: 44px;
  }

  .accept-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 433px;
    max-width: 100%;
    padding: 10px;
    border: 0;
    border-radius: 80px;
    background: ${GREEN};
    color: ${(props) => props.theme.$white};
    font-family: ${POPPINS_FAMILY};
    font-size: 18px;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    transition: filter 0.15s ease;

    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      filter: brightness(1.08);
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.7;
    }

    img {
      flex-shrink: 0;
    }
  }

  .roles {
    position: relative;
    display: flex;
    min-height: 452px;
    background: ${TEXTURED_GREEN};
  }

  .roles-photo {
    flex: 0 0 47.66%;
    width: 47.66%;
    min-height: 452px;
    border-radius: 0 44px 44px 0;
    object-fit: cover;
    object-position: 75% center;
  }

  .roles-content {
    flex: 1;
    min-width: 0;
    padding: 75px 77px 85px 58px;
    color: #eaeaea;

    h2 {
      color: ${(props) => props.theme.$white};
      font-size: 28px;
    }

    ul {
      margin: 23px 0 0;
      padding: 0;
      list-style: none;
    }

    li {
      display: flex;
      flex-direction: column;
      padding: 19px 0;
      border-top: 1px solid rgba(255, 255, 255, 0.24);
      font-size: 18px;
      font-weight: 400;

      &:first-child {
        padding-top: 0;
        border-top: 0;
      }

      &:last-child {
        padding-bottom: 0;
      }
    }

    strong {
      font-weight: 700;
    }
  }

  .join {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 97px 16px 69px;
    text-align: center;

    h2 {
      color: ${GREEN};
    }

    p {
      max-width: 635px;
      margin-top: 11px;
      font-size: 18px;
      font-weight: 300;
    }

    .accept-action {
      margin-top: 37px;
    }
  }

  @media only screen and (max-width: 991px) {
    .hero {
      flex-direction: column;
      align-items: stretch;
      gap: 32px;
      height: auto;
      padding: 48px 16px 56px;
    }

    .hero-text,
    .hero-video {
      flex: none;
    }

    .hero-text {
      h1 {
        font-size: 30px;
        line-height: 1.25;
      }

      p {
        font-size: 17px;
      }
    }

    .green-bar {
      left: 0;
      width: calc(100% - 32px);
    }

    h2 {
      font-size: 26px;
    }

    .benefit-list {
      flex-direction: column;
      gap: 16px;
    }

    .benefit-card {
      flex: none;
      min-height: 0;
    }

    .roles {
      flex-direction: column;
    }

    .roles-photo {
      flex: none;
      width: 100%;
      min-height: 0;
      height: 260px;
      border-radius: 0 0 44px 44px;
      object-position: center;
    }

    .roles-content {
      padding: 40px 16px 56px;

      h2 {
        font-size: 24px;
      }

      li {
        font-size: 16px;
      }
    }

    .accept-button {
      padding: 10px 16px;
      font-size: 13px;
    }

    .join {
      padding-top: 64px;
    }
  }
`;
